import React, { useState } from 'react';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartTrendline from 'chartjs-plugin-trendline';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, ChartTrendline);

const COLORS = {
  lav: '#008550',
  høj: '#EFB700',
  spids: '#B71D13',
};

const MonthlyLoadLineChart = ({ monthlyData, valueType, setValueType }) => {
//   const [valueType, setValueType] = useState('averageHourlyProportionConsumption'); // or 'averageHourlyTotalConsumption'

  // Sort data by year + month
  const sorted = [...monthlyData].sort((a, b) =>
    a.year !== b.year ? a.year - b.year : a.month - b.month
  );

  const labels = Array.from(
    new Set(sorted.map((d) => `${d.year}-${String(d.month).padStart(2, '0')}`))
  );

  const loadTypes = ['lav', 'høj', 'spids'];

  const datasets = loadTypes.map((type) => {
    const data = labels.map((label) => {
      const [year, month] = label.split('-');
      const match = sorted.find(
        (d) => d.year === parseInt(year) && d.month === parseInt(month) && d.last === type
      );
      return match ? match[valueType] : null;
    });

    return {
      label: type.charAt(0).toUpperCase() + type.slice(1) + ' last',
      data,
      borderColor: COLORS[type],
      backgroundColor: COLORS[type],
      fill: false,
      tension: 0.3,
      trendlineLinear: {
    style: 'rgba(0,0,0,0.4)',
    lineStyle: 'dotted',
    width: 2,
    projection: false,
  },
    };
  });

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // important!
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            valueType === 'averageHourlyTotalConsumption'
              ? `${ctx.dataset.label}: ${ctx.parsed.y.toFixed(2)} kWh`
              : `${ctx.dataset.label}: ${(ctx.parsed.y * 100).toFixed(4)}%`,
        },
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text:
            valueType === 'averageHourlyTotalConsumption'
              ? 'Gns. forbrug (kWh/time)'
              : 'Andel af dagligt forbrug (%)',
        },
        ticks: {
          callback: (value) =>
            valueType === 'averageHourlyTotalConsumption'
              ? value
              : `${(value * 100).toFixed(2)}%`,
        },
        // min: 0.0008,           // or your chosen minimum
        // max: 0.0015             // or your chosen maximum
      },
      x: {
        title: {
          display: true,
          text: 'Måned',
        },
      },
    },
  };

return (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ width: 300, marginBottom: 0, marginTop:2 }}>
      <FormControl fullWidth>
        <InputLabel id="value-type-label">Visning</InputLabel>
        <Select
          labelId="value-type-label"
          id="value-type"
          value={valueType}
          label="Visning"
          onChange={(e) => setValueType(e.target.value)}
        >
          <MenuItem value="averageHourlyProportionConsumption">
            Andel af dagligt forbrug (%)
          </MenuItem>
          <MenuItem value="averageHourlyTotalConsumption">
            Gns. forbrug (kWh/time)
          </MenuItem>
        </Select>
      </FormControl>
    </Box>

    <Box sx={{ width: '100%', height: '600px' }}>
      <Line data={chartData} options={options} />
    </Box>
  </Box>
);
};

export default MonthlyLoadLineChart;
